import * as React from "react";

import type { RibbonButtonProps } from "../../RibbonButton/next";
import { renderButton_unstable } from "@fluentui/react-components";
import { AppTooltipContainer } from "@1js/acui-tooltip";
import { useRibbonSplitButtonPrimaryButton } from "./useRibbonSplitButtonPrimaryButton";
import { useRibbonSplitButtonPrimaryButtonStyles } from "./useRibbonSplitButtonPrimaryButtonStyles.styles";

export const RibbonSplitButtonPrimaryButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonButtonProps>((props, ref) => {
    const state = useRibbonSplitButtonPrimaryButton(props, ref);

    useRibbonSplitButtonPrimaryButtonStyles(state);

    return (
      <AppTooltipContainer {...props}>
        {renderButton_unstable(state)}
      </AppTooltipContainer>
    );
  })
);

RibbonSplitButtonPrimaryButton.displayName =
  "next/RibbonSplitButtonPrimaryButton";
